/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Type} from '@angular/core';

import {EmailTranslationEditPageComponent} from '../../admin/email-translation/email-translation-edit-page.component';

const EDIT_COMPONENTS: Record<string, Type<any>> = {
  'email-translation': EmailTranslationEditPageComponent
};

export function getAdminResourceEditComponent(editKey: string): Type<any> | undefined {
  return EDIT_COMPONENTS[editKey];
}
